import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { saFetch, SALoading, fmtDate } from "./saCommon";
import { Badge } from "@/components/ui/badge";
import { CreditCard } from "@phosphor-icons/react";

const STATUS = {
  active: { label: "Activa", cls: "border-emerald-500/40 text-emerald-500" },
  past_due: { label: "Vencida", cls: "border-red-500/40 text-red-400" },
  cancelled: { label: "Cancelada", cls: "border-border text-muted-foreground" },
  trial: { label: "Prueba", cls: "border-sky-500/40 text-sky-500" },
};

export default function SASuscripciones() {
  const [subs, setSubs] = useState(null);

  const load = useCallback(() => {
    saFetch("/superadmin/subscriptions").then(setSubs).catch((e) => toast.error(e.message));
  }, []);
  useEffect(load, [load]);

  if (!subs) return <SALoading label="Cargando suscripciones..." />;

  return (
    <div data-testid="sa-suscripciones">
      <div className="mb-6">
        <h1 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight text-foreground">Suscripciones</h1>
        <p className="text-sm text-muted-foreground mt-1">{subs.length} suscripción(es) registradas</p>
      </div>

      {subs.length === 0 ? (
        <div className="border border-border rounded-sm p-10 text-center text-muted-foreground bg-card" data-testid="sa-subs-empty">
          <CreditCard size={28} className="mx-auto mb-3" />
          Aún no hay suscripciones. Aparecerán cuando las empresas paguen un plan o les asignes uno.
        </div>
      ) : (
        <div className="border border-border rounded-sm overflow-x-auto bg-card">
          <table className="w-full text-sm min-w-[820px]" data-testid="sa-subs-table">
            <thead>
              <tr className="text-left text-xs uppercase tracking-widest text-muted-foreground border-b border-border">
                <th className="p-3 font-normal">Empresa</th>
                <th className="p-3 font-normal">Plan</th>
                <th className="p-3 font-normal">Ciclo</th>
                <th className="p-3 font-normal">Estado</th>
                <th className="p-3 font-normal">Periodo actual</th>
                <th className="p-3 font-normal">Renovación</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border">
              {subs.map((s) => {
                const st = STATUS[s.status] || STATUS.active;
                return (
                  <tr key={s.tenant_id} className="hover:bg-muted/70 transition-colors duration-200" data-testid={`sa-sub-row-${s.tenant_id}`}>
                    <td className="p-3 text-foreground font-medium">{s.company_name || s.tenant_id.slice(0, 8)}</td>
                    <td className="p-3">
                      <span className="text-foreground/80">{s.plan_name || "Gratuito"}</span>
                      {s.is_free && <Badge variant="outline" className="ml-2 rounded-sm border-emerald-500/40 text-emerald-500 font-normal">Gratis</Badge>}
                    </td>
                    <td className="p-3 text-foreground/80">{s.billing_cycle === "annual" ? "Anual" : "Mensual"}</td>
                    <td className="p-3">
                      <Badge variant="outline" className={`rounded-sm font-normal ${st.cls}`}>{st.label}</Badge>
                    </td>
                    <td className="p-3 text-foreground/80 text-xs">
                      {fmtDate(s.current_period_start)} → {fmtDate(s.current_period_end)}
                    </td>
                    <td className="p-3 text-foreground/80 text-xs">{s.auto_renew === false ? "Manual" : "Automática"}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
